import request from "@/router/axios";

export const list = (parentId) => {
  return request({
    url: `/api/basis/hospital/building/list`,
    method: "post",
    data: {
      filterParams: [{ name: "parentId", value: parentId || "0" }],
      orderBy: parentId ? "sortNo" : "name",
      isDesc: !parentId,
    },
  });
};
export const deptList = () => {
  return request({
    url: `/api/basis/dept/info/list`,
    method: "post",
    data: {
      orderBy: "sortNo",
      isDesc: false,
    },
  });
};
export const setDeptBuild = (buildLevelId, deptIds) => {
  return request({
    url: `/api/basis/dept/info/setDeptBuild`,
    method: "post",
    params: {
      buildLevelId,
      deptIds,
    },
  });
};
export const add = (data) => {
  return request({
    url: `/api/basis/hospital/building/add`,
    method: "post",
    data: data,
  });
};
export const batchAdd = (data) => {
  return request({
    url: `/api/basis/hospital/building/batchAdd`,
    method: "post",
    data: data,
  });
};
export const saveSort = (data) => {
  return request({
    url: `/api/basis/hospital/building/saveSort`,
    method: "post",
    data: data,
  });
};
export const edit = (data) => {
  return request({
    url: `/api/basis/hospital/building/edit`,
    method: "post",
    data: data,
  });
};
export const remove = (ids) => {
  return request({
    url: `/api/basis/hospital/building/del`,
    method: "post",
    params: { ids },
  });
};
